import Vue from 'vue'
import Vuex from 'vuex'
import { mapState, mapGetters, mapActions } from 'vuex'

let api = ''
if (document.location.hostname == '10.1.10.175') {
    // our in-house server
    api = 'http://10.1.10.175/navigator/api/api.php'
} else {
    let developmentEnvironment = (document.location.hostname == 'localhost' || document.location.hostname.indexOf('.test') > -1)
    let hostname = developmentEnvironment ? 'navigator.test' : document.location.hostname + '/navigatorapi'
    api = 'https://' + hostname + '/api.php'
}

// DEBUG...
//api = 'http://10.1.10.175:8080/api/api.php'

Vue.use(Vuex)

// instantiate store as a constant and export below to make globally available
const store = new Vuex.Store({
    state: {
        apiEndpoint: api,
        loading: true,
        loginRequired: true,
        user: {},
        items: [],
        filters: {},
        totals: {},
        paging: {},
        department_name: '',
        globalReportYear: sessionStorage.getItem('report_year') || (new Date()).getFullYear(),
        debug_end_date: ''
    },
    mutations: {
        UPDATE_LOADING(state, loading) {
			state.loading = loading
		},
		UPDATE_LOGIN_REQUIRED(state, value) {
			state.loginRequired = value
		},
		UPDATE_STATE(state, obj) {
			for (let prop in state) {
				if (obj.hasOwnProperty(prop)) {
					state[prop] = obj[prop]
				}
			}
		},
        UPDATE_FILTERS(state, filters) {
			state.filters = JSON.parse(JSON.stringify(filters));
		},
        UPDATE_TOTALS(state, totals) {
			state.totals = JSON.parse(JSON.stringify(totals));
		},
        UPDATE_USER(state, user) {
			state.user = user
		},
        UPDATE_REPORT_YEAR(state, reportYear) {
			state.globalReportYear = reportYear
		}
    },
    getters: {
        getApiEndpoint(state) {
            return state.apiEndpoint
        },
        getLoginRequired(state) {
            return state.loginRequired
        },
        getLoading(state) {
            return state.loading
        },
        getUser(state) {
            return state.user
        },
        getItems(state) {
            return state.items
        },
        getFilters(state) {
            return state.filters
        },
        getTotals(state) {
            return state.totals
        },
        getPaging(state) {
            return state.paging
        },
        getDepartmentName(state) {
            return state.department_name
        },
        getReportYear(state) {
            return state.globalReportYear
        },
        getDebugEndDate(state) {
            return state.debug_end_date
        }
    },
    actions: {
        updateLoading({ commit }, value) {
			commit('UPDATE_LOADING', value)
		},
        updateUser({ commit }, user) {
			commit('UPDATE_USER', user)
		},
        updateLoginRequired({ commit }, value) {
			commit('UPDATE_LOGIN_REQUIRED', value)
		},
        updateReportYear({ commit }, reportYear) {
			commit('UPDATE_REPORT_YEAR', reportYear)
            sessionStorage.setItem('report_year', reportYear)
        },
        storeFilters({ commit }, filters) {
			commit('UPDATE_FILTERS', filters)
		},
        storeTotals({ commit }, totals) {
			commit('UPDATE_TOTALS', totals)
		},
        apiCall({ state, commit }, parameters) {
            return new Promise((resolve, reject) => {
                // expected parameters: destination, data, headers, callback
                let url = (parameters.destination.indexOf('.') > 0) ? parameters.destination : state.apiEndpoint + '?action=' + parameters.destination
                if (!('data' in parameters)) { parameters.data = {} }
                // copy parameters to a new object so adding system-wide values won't update the original object
                let postData = JSON.parse(JSON.stringify(parameters));
                // add system-wide variables to the new object
                postData.data.source = state.source
                postData.data.report_year = sessionStorage.getItem('report_year')
                postData.data.user_id = sessionStorage.getItem('user_id')
                let defaultHeaders = {
                    method: 'post',
                    body: JSON.stringify(postData.data),
                    credentials: 'include'
                }
                let headers = postData.headers || defaultHeaders
                fetch(url, headers).then(function(response) {
                    return response.json()
                }).then(obj => {
                    commit('UPDATE_LOADING', false)
                    if (obj.error) {
                        console.log('error!')
                        obj.error.status = 'error'
                        resolve(obj.error)
                    } else {
                        if (obj.status == 'login_required' || (obj.user && !obj.user.user_name)) {
                            commit('UPDATE_LOGIN_REQUIRED', true)
                            if (document.location.pathname != '/') {
                                document.location.replace('/?return=' + document.location.pathname)
                            }
                        } else {
                            if (obj.user && obj.user.user_name) {
                                sessionStorage.setItem('user_id', obj.user.user_id)
                                sessionStorage.setItem('user_name', obj.user.user_name)
                                sessionStorage.setItem('user_type_code', obj.user.user_type_code)
                            }
                            commit('UPDATE_LOGIN_REQUIRED', false)
                        }
                        commit('UPDATE_STATE', obj)
                    }
                    resolve(obj)
                }).catch(error => {
                    console.log('error', error)
                    if (error == 'TypeError: Failed to fetch') {
                        // document.location.reload()
                    }
                    reject(error)
                })
            })
		}
    }
})

export default store;

// import { mapState, mapGetters, mapActions } from 'vuex'
// Vue.use(mapGetters)
// Vue.use(mapState)
// Vue.use(mapActions)

store.allGetters = Reflect.ownKeys(store.getters)
store.allActions = Reflect.ownKeys(store._actions)

Vue.mixin({
	methods: {
		...mapActions(store.allActions),
        formatNumber: function(number, asHTMLCurrency = false) {
            if (number) {
                var formattedNumber = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                if (asHTMLCurrency) {
                    var numberParts = formattedNumber.split('.')
                    return '<sup>$</sup>' + numberParts[0] + '<sup>' + numberParts[1] + '</sup>'
                } else {
                    return formattedNumber
                }
            } else {
                return '0.00'
            }
        }
	},
	computed: {
		...mapGetters(store.allGetters)
	}
})
